<a class="row mt-3" (click)="doLinkClick($event)" *transloco="let t"
  [attr.aria-label]="cta_label ? cta_label : t('call_to_action.'+cta_type)">
  <div class="top-content row">
    @if (image()) {
      <div class="col-4">
        <img class="img-responsive w-100"
          [src]="image() | imageUrl:imageTransformations"
          [alt]="image()?.alt_text">
      </div>
    }
    <div [class]="image() ? 'col-8 px-0' : 'col-12 px-2'">
      <p class="font-weight-bold">{{titleText}}</p>
      <p>
        {{description}}
      </p>
    </div>
  </div>
  @if (cta_label || cta_type) {
    <button type="button" class="btn btn-primary btn-sm"
      [attr.aria-label]="cta_label ? cta_label : t('call_to_action.'+cta_type)">
      {{cta_label ? cta_label : t('call_to_action.'+cta_type)}}
    </button>
  }
</a>